export default "__VITE_ASSET__CenximVF__"